
export const VAT = 0.1;
export const PRONOUNS_OTHER = 221120003;
